import Vue from 'vue';
export default Vue.extend({
    props: {
        input: Object
    },
    data: function () { return ({
        checked: []
    }); }
});
